<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="92%" append-to-body @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="showViewToolbar" class="doc-dialog-actions">
          <el-button-group>
            <workflow-doc-buttons biz-type="otherIn" :biz-id="form.stockInId" perm="inventory:otherIn" :approve-status="String(form.approveStatus || '0')" @approve="approve(true)" @unapprove="approve(false)" />
            <el-button v-if="isAuth('inventory:otherIn:update')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="readonly = false">修改</el-button>
            <el-button v-if="isAuth('inventory:otherIn:delete')" type="primary" size="small" :disabled="!canEditDoc || actionBusy" @click="remove">删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>

    <el-form ref="dataForm" :model="form" label-width="90px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="入库单号" required>
            <el-input v-model="form.stockInCode" :disabled="formDisabled || codeReadonly || !!form.stockInId" :placeholder="codeReadonly ? '保存时自动编号' : ''" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="入库日期" required>
            <el-date-picker v-model="form.stockInDate" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="formDisabled" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="供应商">
            <el-input v-model="form.belongSupplierName" readonly placeholder="选择供应商" :disabled="formDisabled">
              <el-button v-if="!formDisabled" slot="append" icon="el-icon-search" @click="supplierVisible = true" />
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="备注">
            <el-input v-model="form.remark" :disabled="formDisabled" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.stockInId">
        <el-col :span="6">
          <el-form-item label="审核状态">
            <el-tag :type="statusTagType" size="small">{{ statusText }}</el-tag>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="inventoryBarcodeEnabled && !formDisabled" class="line-tools">
      <el-input v-model="barcodeScanCode" size="small" placeholder="扫描条码解析物料（非序列号）" clearable style="width:320px;" @keyup.enter.native="onBarcodeScanForLine" />
      <el-button type="primary" size="small" style="margin-left:8px;" @click="onBarcodeScanForLine">扫码加行</el-button>
    </div>
    <div class="line-tools">
      <el-button v-if="!formDisabled" type="primary" size="small" @click="addLine">新增行</el-button>
      <el-button v-if="!formDisabled" type="primary" size="small" style="margin-left:8px;" @click="materialVisible = true">选择物料</el-button>
      <el-upload v-if="!formDisabled" :show-file-list="false" action="" :http-request="doImport" accept=".xlsx" style="display:inline-block;margin-left:8px;">
        <el-button type="primary" size="small">导入(产品编码)</el-button>
      </el-upload>
      <el-button v-if="!formDisabled" size="small" style="margin-left:8px;" @click="downloadTemplate">下载导入模板</el-button>
    </div>

    <el-table border :data="form.lines" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
      <el-table-column type="index" label="序号" header-align="center" align="center" width="60" />
      <el-table-column label="产品编码" header-align="center" min-width="140">
        <template slot-scope="scope">
          <el-input v-model="scope.row.materialCode" :disabled="formDisabled" placeholder="输入产品编码" @blur="fillLine(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column prop="materialName" label="产品名称" header-align="center" min-width="140" />
      <el-table-column prop="customerCode" label="客户编码" header-align="center" min-width="120" />
      <el-table-column prop="specs" label="规格型号" header-align="center" min-width="120" />
      <el-table-column prop="materialAttributeText" label="配置" header-align="center" min-width="130" show-overflow-tooltip />
      <el-table-column v-if="inventoryBarcodeEnabled" label="序列号" header-align="center" min-width="280">
        <template slot-scope="scope">
          <inventory-line-serial-panel v-if="isSerialMaterial(scope.row)" :value="scope.row.serialNos" :expected-qty="serialExpectedQty(scope.row)" :readonly="formDisabled" @input="v => $set(scope.row, 'serialNos', v)" />
          <span v-else style="color:#909399;">—</span>
        </template>
      </el-table-column>
      <el-table-column label="入库数量" header-align="center" width="160">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.quantity" :disabled="formDisabled" :min="0" :precision="2" style="width:100%" />
        </template>
      </el-table-column>
      <el-table-column label="入库仓库" header-align="center" min-width="250">
        <template slot-scope="scope"><warehouse-location-select v-model="scope.row.wareHouseId" :disabled="formDisabled" /></template>
      </el-table-column>
      <el-table-column label="批号" header-align="center" min-width="120">
        <template slot-scope="scope"><el-input v-model="scope.row.batchNo" :disabled="formDisabled" /></template>
      </el-table-column>
      <el-table-column v-if="inventoryQtyShowSupplier" label="供应商" header-align="center" min-width="120">
        <template slot-scope="scope"><el-input v-model="scope.row.supplierName" :disabled="formDisabled" /></template>
      </el-table-column>
      <el-table-column label="备注" header-align="center" min-width="120">
        <template slot-scope="scope"><el-input v-model="scope.row.remark" :disabled="formDisabled" /></template>
      </el-table-column>
      <el-table-column v-if="!formDisabled" fixed="right" label="操作" width="70" header-align="center" align="center">
        <template slot-scope="scope"><el-button type="text" size="small" @click="form.lines.splice(scope.$index, 1)">删除</el-button></template>
      </el-table-column>
    </el-table>

    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!formDisabled" type="primary" :loading="saving" @click="save">确定</el-button>
    </span>

    <material-selector :visible.sync="materialVisible" multiple @select-multiple="chooseMaterials" />
    <supplier-selector :visible.sync="supplierVisible" @select="onSupplierSelect" />
  </el-dialog>
</template>

<script>
import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import WarehouseLocationSelect from '../../components/WarehouseLocationSelect.vue'
import MaterialSelector from '../../components/MaterialSelector.vue'
import SupplierSelector from '../../components/SupplierSelector.vue'
import InventoryLineSerialPanel from '../../components/InventoryLineSerialPanel.vue'
import { today, fillMaterialRow, downloadInventoryTemplate, importInventoryLines, showImportError, postDoc, loadAttributeText, loadAttributeTexts } from './inventoryShared'
import inventoryQtyShowSupplierMixin from '../../mixins/inventory-qty-show-supplier'
import inventoryBarcodeMixin from '../../mixins/inventory-barcode'
import { workflowStatusText, workflowStatusTagType } from '../../utils/workflow'

export default {
  name: 'OtherInAddOrUpdate',
  components: { WorkflowDocButtons, WarehouseLocationSelect, MaterialSelector, SupplierSelector, InventoryLineSerialPanel },
  mixins: [inventoryQtyShowSupplierMixin, inventoryBarcodeMixin],
  data() {
    return {
      kind: 'otherIn',
      visible: false,
      readonly: false,
      saving: false,
      actionBusy: false,
      codeReadonly: false,
      materialVisible: false,
      supplierVisible: false,
      permCodes: [],
      form: this.blank()
    }
  },
  computed: {
    formDisabled() {
      const wf = this.form.workflowStatus
      return this.readonly || String(this.form.approveStatus) === '2' || !!(wf && wf !== 'draft' && wf !== 'rejected')
    },
    canEditDoc() {
      const wf = this.form.workflowStatus
      return String(this.form.approveStatus) !== '2' && (!wf || wf === 'draft' || wf === 'rejected')
    },
    showViewToolbar() { return this.readonly && !!this.form.stockInId },
    dialogTitle() {
      if (this.readonly || String(this.form.approveStatus) === '2') return '查看其它入库'
      return this.form.stockInId ? '修改其它入库' : '新增其它入库'
    },
    statusText() { return workflowStatusText(this.form.workflowStatus, this.form.approveStatus) },
    statusTagType() { return workflowStatusTagType(this.form.workflowStatus, this.form.approveStatus) }
  },
  created() {
    this.loadPerms()
    this.loadInventoryQtyShowSupplierPolicy()
    this.loadInventoryBarcodePolicy()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() {
      fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
    },
    blank() {
      return {
        stockInId: '', stockInCode: '', stockInDate: today(),
        belongSupplierId: '', belongSupplierName: '', remark: '', approveStatus: '0', workflowStatus: '', lines: []
      }
    },
    init(id, readonly) {
      this.visible = true
      this.readonly = !!readonly
      this.codeReadonly = false
      this.actionBusy = false
      this.form = this.blank()
      if (!id) { this.resolveCode(); return }
      request.get('/inventory/otherIn/info/' + id).then(res => {
        const data = res.data || {}
        this.form = Object.assign(this.blank(), data, {
          lines: data.lines || [],
          approveStatus: data.approveStatus != null ? String(data.approveStatus) : '0'
        })
        loadAttributeTexts(this.form.lines, this)
      }).catch(() => {})
    },
    onClosed() {
      this.form = this.blank()
      this.readonly = false
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'otherIn' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (this.codeReadonly && data.previewCode) this.form.stockInCode = data.previewCode
      }).catch(() => {})
    },
    onSupplierSelect(row) {
      this.form.belongSupplierId = row.supplierId || ''
      this.form.belongSupplierName = row.supplierName || ''
    },
    addLine() {
      this.form.lines.push({
        materialCode: '', materialName: '', customerCode: '', specs: '', barcodeManageMode: 'none', serialNos: [],
        quantity: 0, wareHouseId: '', fromWareHouseId: '', toWareHouseId: '', batchNo: '', supplierName: '', remark: ''
      })
    },
    fillLine(row) {
      fillMaterialRow(row).then(m => { if (m === null) this.$message.warning('未找到该产品编码'); else loadAttributeText(row, this) }).catch(() => {})
    },
    chooseMaterials(materials) {
      (materials || []).forEach(m => {
        const hit = this.form.lines.find(item => item.materialCode === m.materialCode)
        if (hit) { hit.quantity = Number((Number(hit.quantity || 0) + 1).toFixed(2)); return }
        const row = {
          materialId: m.materialId, materialCode: m.materialCode, materialName: m.materialName,
          customerCode: m.customerCode || '', specs: m.specs || '', barcodeManageMode: m.barcodeManageMode || 'none', serialNos: [],
          quantity: 1, wareHouseId: '', fromWareHouseId: '', toWareHouseId: '', batchNo: '', supplierName: '', remark: ''
        }
        this.form.lines.push(row)
        loadAttributeText(row, this)
      })
    },
    downloadTemplate() { downloadInventoryTemplate('otherIn', '其他入库导入模板.xlsx').catch(() => this.$message.error('模板下载失败')) },
    doImport(req) {
      importInventoryLines('otherIn', req.file).then(lines => {
        lines.forEach(item => {
          const row = {
            materialId: item.materialId, materialCode: item.materialCode, materialName: item.materialName || '',
            customerCode: item.customerCode || '', specs: item.specs || '', barcodeManageMode: item.barcodeManageMode || 'none', serialNos: [],
            quantity: item.quantity, wareHouseId: item.wareHouseId || '', batchNo: item.batchNo || '', supplierName: '', remark: item.remark || ''
          }
          this.form.lines.push(row)
          loadAttributeText(row, this)
        })
        this.$message.success('导入成功')
      }).catch(e => showImportError(this, e))
    },
    save() {
      if (!this.codeReadonly && !(this.form.stockInCode || '').trim()) { this.$message.error('入库单号不能为空'); return }
      if (!this.form.stockInDate) { this.$message.error('入库日期不能为空'); return }
      if (!this.form.lines.length) { this.$message.error('请至少维护一条明细'); return }
      const id = this.form.stockInId
      const body = {
        id, code: this.form.stockInCode, bizDate: this.form.stockInDate,
        stockInId: id, stockInCode: this.form.stockInCode, stockInDate: this.form.stockInDate,
        belongSupplierId: this.form.belongSupplierId, belongSupplierName: this.form.belongSupplierName,
        remark: this.form.remark, lines: this.form.lines
      }
      this.saving = true
      postDoc('otherIn', body, id).then(() => {
        this.$message.success('操作成功')
        this.visible = false
        this.$emit('refreshDataList')
      }).catch(() => {}).finally(() => { this.saving = false })
    },
    approve(pass) {
      const id = this.form.stockInId
      this.$confirm(pass ? '审核后将更新库存现存量，是否继续?' : '弃审将冲回对应库存，是否继续?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        request.post('/inventory/otherIn/' + (pass ? 'approve' : 'unapprove'), { id }).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    },
    remove() {
      this.$confirm('确定删除该单据?', '提示', { type: 'warning' }).then(() => {
        this.actionBusy = true
        request.post('/inventory/otherIn/delete', { id: this.form.stockInId }).then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionBusy = false })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
.doc-dialog-actions .el-button { margin-left: 0; }
.line-tools { margin-bottom: 10px; }
</style>
